<template>
    <!--版本申请-->
    <div class="editionbox">
        <headerbox :focus="6"></headerbox>
        <div class="fonts">欢迎3PL物流商加入IDA云物流

        </div>
        <div style="position: relative">
            <div class="imgbox"></div>

            <div class="editionschange">
                <div class="changebox">
                    <div class="change1">
                        <div class="change1s">
                            <img src="../../public/statics/img/editon/green.png" alt=""/>
                            <p class="change1sf1">INCLUSIVE</p>
                            <span class="change1sf2">IDA普惠云</span>
                        </div>
                        <div class="content1">
                            <div class="content11">
                                <p>端口报价</p>
                            </div>
                            <div class="content12">
                                <p>免费</p>
                            </div>
                        </div>
                        <div class="content2"></div>
                        <div class="content3">
                            <div class="content31">
                                <div class="content3s">
                                    <span class="content3s1">基础运输模块</span>
                                    <span class="content3s2">(必选)</span>
                                </div>
                                <el-popover
                                        placement="top-start"
                                        width="200"
                                        trigger="hover"
                                        content="适用于小规模的运输业务管理模式，满足接单、调度、跟踪、回单、对账及结算等基础运输管理。">
                                    <i slot="reference" class="el-icon-info"></i>
                                </el-popover>

                            </div>
                            <div class="content32">
                                <span class="content321">￥500/月</span>
                                <span class="content322">(￥6000/年)</span>
                            </div>
                        </div>

                    </div>
                    <div class="change1">
                        <div class="change1s">
                            <img src="../../public/statics/img/editon/blue.png" alt=""/>
                            <p class="change1sf1">TRANSPORT</p>
                            <span class="change1sf2">IDA云运输</span>
                        </div>
                        <div class="content1">
                            <div class="content11">
                                <p>端口报价</p>
                                <span>(5个起售)</span>
                            </div>
                            <div class="content12">
                                <p>￥300/月/个</p>
                                <span>(￥3600/年)</span>
                            </div>
                        </div>
                        <div class="content2"></div>
                        <div class="content3">
                            <div class="content31">
                                <div class="content3s">
                                    <span class="content3s1">直运管理模块</span>
                                    <span class="content3s2">(必选)</span>
                                </div>
                                <el-popover
                                        placement="top-start"
                                        width="200"
                                        trigger="hover"
                                        content="适用于车辆提货后直接承运干线运输的3PL调度模式，并可添加末端派送承运人。可满足所有单点及多点提送货环境下的城际、城配等汽运业务场景。">
                                    <i slot="reference" class="el-icon-info" style="color: #5098d1;"></i>
                                </el-popover>
                            </div>
                            <div class="content32">
                                <span class="content321">￥4000/月</span>
                                <span class="content322">(￥48000/年)</span>
                            </div>
                        </div>
                        <div class="content3">
                            <div class="content31">
                                <div class="content3s">
                                    <span class="content3s1">转运管理模块</span>
                                </div>
                                <el-popover
                                        placement="top-start"
                                        width="200"
                                        trigger="hover"
                                        content="适用于提货车辆提货后再转交给一级或多级干线承运人发运的3PL调度模式。可满足汽运、铁运、空运、水运等所有多联式运输业务场景。">
                                    <i slot="reference" class="el-icon-info" style="color: #5098d1;"></i>
                                </el-popover>
                            </div>
                            <div class="content32">
                                <span class="content321">￥1500/月</span>
                                <span class="content322">(￥18000/年)</span>
                            </div>
                        </div>
                        <div class="content3">
                            <div class="content31">
                                <div class="content3s">
                                    <span class="content3s1">配载管理模块</span>
                                </div>
                                <el-popover
                                        placement="top-start"
                                        width="200"
                                        trigger="hover"
                                        content="适用于提货车辆提货后先进入3PL中转库，再重新配载发运的3LP调度模式。可满足所有需要集货中转后再自主配载发运的运输业务场景。">
                                    <i slot="reference" class="el-icon-info" style="color: #5098d1;"></i>
                                </el-popover>
                            </div>
                            <div class="content32">
                                <span class="content321">￥1500/月</span>
                                <span class="content322">(￥18000/年)</span>
                            </div>
                        </div>
                        <div class="content3">
                            <div class="content31">
                                <div class="content3s">
                                    <span class="content3s1">费用结算模块</span>
                                </div>
                                <el-popover
                                        placement="top-start"
                                        width="200"
                                        trigger="hover"
                                        content="运输业务中所有应收、应付费用的智能辅助录入，以及费用核对、审核、结算等财务交互功能。">
                                    <i slot="reference" class="el-icon-info" style="color: #5098d1;"></i>
                                </el-popover>
                            </div>
                            <div class="content32">
                                <span class="content321">￥1000/月</span>
                                <span class="content322">(￥12000/年)</span>
                            </div>
                        </div>

                    </div>
                    <div class="change1">
                        <div class="change1s">
                            <img src="../../public/statics/img/editon/purple.png" alt=""/>
                            <p class="change1sf1">PACKAGING</p>
                            <span class="change1sf2">IDA云包装</span>
                        </div>
                        <div class="content1">
                            <div class="content11">
                                <p>端口报价</p>
                                <span>(5个起售)</span>
                            </div>
                            <div class="content12">
                                <p>￥300/月/个</p>
                                <span>(￥3600/年)</span>
                            </div>
                        </div>
                        <div class="content2"></div>
                        <div class="content3">
                            <div class="content31">
                                <div class="content3s">
                                    <span class="content3s1">循环管理模块</span>
                                    <span class="content3s2">(必选)</span>
                                </div>
                                <el-popover
                                        placement="top-start"
                                        width="200"
                                        trigger="hover"
                                        content="通过智能硬件和终端设备，实现循环包装的货物装箱、空箱回收以及返箱调度等管理。">
                                    <i slot="reference" class="el-icon-info" style="color: #ddb8d6;"></i>
                                </el-popover>
                            </div>
                            <div class="content32">
                                <span class="content321">￥5000/月</span>
                                <span class="content322">(￥60000/年)</span>
                            </div>
                        </div>
                        <div class="content3">
                            <div class="content31">
                                <div class="content3s">
                                    <span class="content3s1">租赁管理模块</span>
                                </div>
                                <el-popover
                                        placement="top-start"
                                        width="200"
                                        trigger="hover"
                                        content="适用于循环包装的动态租赁和静态租赁业务场景，通过智能辅助功能，实现租赁过程中的合同周期、用量统计、租金计算等智能管理。">
                                    <i slot="reference" class="el-icon-info" style="color: #ddb8d6;"></i>
                                </el-popover>
                            </div>
                            <div class="content32">
                                <span class="content321">￥2000/月</span>
                                <span class="content322">(￥24000/年)</span>
                            </div>
                        </div>
                        <div class="content3">
                            <div class="content31">
                                <div class="content3s">
                                    <span class="content3s1">包装盘点模块</span>
                                </div>
                                <el-popover
                                        placement="top-start"
                                        width="200"
                                        trigger="hover"
                                        content="实现智能辅助模式下的循环包装动态和静态库存盘点，实时掌握循环动态库存。">
                                    <i slot="reference" class="el-icon-info" style="color: #ddb8d6;"></i>
                                </el-popover>
                            </div>
                            <div class="content32">
                                <span class="content321">￥1500/月</span>
                                <span class="content322">(￥18000/年)</span>
                            </div>
                        </div>
                        <div class="content3">
                            <div class="content31">
                                <div class="content3s">
                                    <span class="content3s1">资产管理模块</span>
                                </div>
                                <el-popover
                                        placement="top-start"
                                        width="200"
                                        trigger="hover"
                                        content="通过智能辅助功能，对循环包装在使用过程中资产变化情况进行实时管理，并自动计算和统计折旧费用。">
                                    <i slot="reference" class="el-icon-info" style="color: #ddb8d6;"></i>
                                </el-popover>
                            </div>
                            <div class="content32">
                                <span class="content321">￥1000/月</span>
                                <span class="content322">(￥12000/年)</span>
                            </div>
                        </div>

                    </div>
                    <div class="change1">
                        <div class="change1s">
                            <img src="../../public/statics/img/editon/orange.png" alt=""/>
                            <p class="change1sf1">WAREHOUSE</p>
                            <span class="change1sf2">IDA云仓储</span>
                        </div>
                        <div class="content1">
                            <div class="content11">
                                <p>端口报价</p>
                                <span>(5个起售)</span>
                            </div>
                            <div class="content12">
                                <p>￥300/月/个</p>
                                <span>(￥3600/年)</span>
                            </div>
                        </div>
                        <div class="content2"></div>
                        <div class="content3">
                            <div class="content31">
                                <div class="content3s">
                                    <span class="content3s1">
                  出入库/库位管理模块

                </span>
                                    <span class="content3s2">(必选)</span>
                                </div>
                                <el-popover
                                        placement="top-start"
                                        width="200"
                                        trigger="hover"
                                        content="支持移动终端和智能设备，无缝对接云运输系统，实现实时出入库以及库存管理，满足虚拟云仓、 VMI、CDC、RDC等仓储业务模式。">
                                    <i slot="reference" class="el-icon-info" style="color: #f3c59e;"></i>
                                </el-popover>
                            </div>
                            <div class="content32">
                                <span class="content321">￥4000/月</span>
                                <span class="content322">(￥48000/年)</span>
                            </div>
                        </div>

                        <div class="content3">
                            <div class="content31">
                                <div class="content3s">
                                    <span class="content3s1">
                库存盘点模块

                </span>
                                </div>
                                <el-popover
                                        placement="top-start"
                                        width="200"
                                        trigger="hover"
                                        content="实现智能辅助模式下的动态和静态库存盘点，实时对库存货物的账、物、卡、证进行精准核对。">
                                    <i slot="reference" class="el-icon-info" style="color: #f3c59e;"></i>
                                </el-popover>
                            </div>
                            <div class="content32">
                                <span class="content321">￥1000/月</span>
                                <span class="content322">(￥12000/年)</span>
                            </div>
                        </div>

                    </div>

                </div>
                <div class="changefont">
                    <div>
                        <i class="el-icon-info" style="color:#fba962;"></i>  第三方系统接口开发费用可根据用户具体需求另外约定
                    </div>
                    <div style="display: flex;">
                      <!--  <div class="bots">
                            <el-popover
                                    placement="bottom"
                                    width="200"
                                    trigger="click">
                                <el-button >click 激活</el-button>



                            </el-popover>

                            <div class="bots1">
                                <div  class="bots1font" @click="bots1showclick()">我是货主</div>
                                <div class="bots1s" v-show="bots1show" ref="treeWrap1">
                                    <img src="../../public/statics/img/yhz_android.jpg" alt="">
                                    <img src="../../public/statics/img/yhz_ios.png" alt="">
                                    <div class="bots1z"></div>
                                    <div class="bots2z"  @click="bots1show=false">x</div>
                                </div>
                            </div>

                            <div class="bots2" style="cursor: auto">|</div>
                            <div class="bots3">
                                <div class="bots3font" @click="bots3showclick()">我是车主</div>
                                <div class="bots3s" v-show="bots3show" ref="treeWrap3">
                                    <img src="../../public/statics/img/ywl_android.jpg" alt="">
                                    <img src="../../public/statics/img/ywl_ios.png" alt="">
                                    <div class="bots1z"></div>
                                    <div class="bots2z" @click="bots3show=false">x</div>

                                </div>

                            </div>
                        </div>-->
                        <el-button type="danger" style="padding: 5px 10px ;" @click="jumppayediton()">前往选购 </el-button>
                    </div>
                </div>




            </div>
        </div>

        <!--升级弹窗-->
        <el-dialog :visible.sync="dialogVisible" width="433px" :show-close="false">
            <div slot="title" class="dialog-footer" style="display: flex;align-items: center;">
                <div
                        style="width:4px;
height:16px;
background:rgba(243,89,89,1);
border-radius:60px;margin-right: 5px;"
                ></div>
                <span
                        style="font-size:18px;font-family:PingFang SC;font-weight:400;color:rgba(51,51,51,1);"
                >确定要<span v-if="editionoption==1">升级</span>
                    <span v-if="editionoption==2">续费</span>该版本吗?</span>
            </div>
            <div style="width:100%; display: flex;flex-wrap: wrap;margin-top: -12px;">
                <div style="line-height: 60px;text-align: center;width: 100%;color:#00aec2;font-size: 34px;"
                     v-if="edition==1">基础版
                </div>
                <div style="line-height: 60px;text-align: center;width: 100%;color:#84c024;font-size: 34px;"
                     v-if="edition==2">专业版
                </div>
                <div style="line-height: 60px;text-align: center;width: 100%;color:#016596;font-size: 34px;"
                     v-if="edition==3">高级版
                </div>

                <span style="width:100%;display: flex;justify-content: flex-end;margin-top: 20px;">
                    <el-button
                            style="width: 64px;height:30px;padding: 0;"
                            type="info"
                            @click="closedvisible()">取消</el-button>
                    <el-button
                            style="width: 64px;height:30px;padding: 0;"
                            type="primary"
                            @click="sure(edition,editionoption)">确认</el-button>
                </span>
            </div>
        </el-dialog>

        <botbox></botbox>

    </div>

</template>

<script>
    import {auth, anth} from '../request/api';
    import headerbox from "../components/boxtop";
    import botbox from "../components/botts";
    import Cookies from 'js-cookie'
    import {getToken, setToken, removeToken} from '../request/toekn'
    import {mapGetters} from "vuex";


    export default {
        name: "edition",
        components: {
            headerbox, botbox
        },
        computed: {
            ...mapGetters(["vip_type", "vip_log"]),
        },
        data() {
            return {
                editionstatus: 0,//是否登录
                // vip_type:2,


                dialogVisible: false,
                editionoption: "",//续费或升级
                edition: "",//续费的版本

                bots1show: false,
                bots3show: false,

                // vip_type:1,
                // vip_log:0,
            }
        },
        mounted() {
            if (Cookies.get(getToken()) && getToken()) {
                this.editionstatus = 1;
            } else {
                this.editionstatus = 0;
            }
        },
        methods: {
            bots1showclick() {
                this.bots1show = !this.bots1show;
                this.bots3show = false;
            },
            bots3showclick() {
                this.bots3show = !this.bots3show;
                this.bots1show = false;
            },


            //申请注册
            toapply(e) {
                this.$router.push({
                    path: '/apply',
                    query: {vip_type: e}
                });
            },
            //升级
            toapplys(e1, e2) {
                this.edition = e1;
                this.editionoption = e2;
                this.dialogVisible = true;
            },
            //续费
            torenew(e1, e2) {
                this.edition = e1;
                this.editionoption = e2;
                this.dialogVisible = true;

            },
            //关闭续费弹窗
            closedvisible() {
                this.renewedition = '';
                this.editionoption = '';
                this.dialogVisible = false;
            },
            //点击确认续费操作
            sure(e, e1) {
                //e 版本 e1 续费||升级
                let url = '/v1/member/user/upgrade';
                let data = {
                    vip_type: e,
                    type: e1
                };
                // return;
                auth(url, data).then(res => {
                    if (res.data.code == 1) {
                        this.getuserinfo();
                        this.dialogVisible = false;
                    } else {
                        this.$message({
                            type: 'error',
                            message: res.data.msg
                        })
                    }
                })
            },
            //获取信息
            getuserinfo() {
                this.$store.dispatch('GetInfo').then(data => {
                    // console.log('成功')
                }).catch((data) => {
                    if (data.data.code == 8000) {
                        this.logout();
                        // this.loading = false;
                    } else {
                        this.$message.error(data);
                        // this.loading = false;
                    }
                })
            },
            // 退出登录
            logout() {
                this.$store.dispatch('LogOut').then(data => {
                    this.$message({
                        type: 'success',
                        message: '退出成功',
                    });
                    this.$router.push({path: '/index',});
                }).catch((data) => {
                    this.$message.error(data.data.msg);
                })
            },

            //跳转支付页面
            jumppayediton(){
                this.$router.push('/editionpay');
            },


        },
    }
</script>

<style scoped lang='scss'>
    .editionbox {
        width: 100%;
        height: 100vh;
        background: #f5f5f5;

        .imgbox {
            width: 100%;
            height: 7.8375rem;
            position: absolute;
            top: 0;
            background-image: url("../../public/statics/img/edition.jpg");
            background-repeat: no-repeat;
            background-size: contain;
            background-position: center;
        }

        .fonts {
            position: absolute;
            left: 0;
            right: 0;
            top: 1.8rem;
            margin: auto;
            color: #ffffff;
            z-index: 9;
            font-family: "PingFang SC";
            font-size: 0.4rem;
        }

        .editions {
            position: absolute;
            left: 0;
            right: 0;
            top: 3rem;
            margin: auto;
            width: 16rem;
            /*width: 15.45rem;*/
            height: 6rem;
            display: flex;
            justify-content: space-between;

            .editionunit {
                width: 5rem;
                height: 7rem;

                box-sizing: border-box;
                background: #FCFCFC;
                box-shadow: 0px 11px 20px 0px rgba(38, 102, 130, 0.21);
                border-radius: 10px;
                position: relative;
                -webkit-box-shadow: 0px 11px 20px 0px rgba(38, 102, 130, 0.21);
                -moz-box-shadow: 0px 11px 20px 0px rgba(38, 102, 130, 0.21);
                display: flex;
                flex-direction: column;
                align-items: center;
                /*justify-content: space-between;*/
                padding-bottom: 0.5rem;

                .edititle {
                    width: 100%;
                    background: #4EAFBE;
                    color: #fff;
                    line-height: 70px;
                    font-family: "PingFang SC";
                    font-size: 0.4rem;
                    border-radius: 10px 10px 0 0;
                    text-align: center;

                }

                .edititle:after {
                    display: block;
                    content: '';
                    position: absolute;
                    right: 0;
                    top: 0;
                    border: 16px solid #4EAFBE;
                    border-left: 16px solid transparent;
                    border-bottom: 16px solid transparent;
                    border-top-right-radius: 10px;
                    z-index: 9;
                }

                .edititle2 {
                    width: 100%;
                    background: #4E8ABE;
                    color: #fff;
                    line-height: 70px;
                    font-family: "PingFang SC";
                    font-size: 0.4rem;
                    border-radius: 10px 10px 0 0;
                    text-align: center;
                }

                .edititle2:after {
                    display: block;
                    content: '';
                    position: absolute;
                    right: 0;
                    top: 0;
                    border: 16px solid #4E8ABE;
                    border-left: 16px solid transparent;
                    border-bottom: 16px solid transparent;
                    border-top-right-radius: 10px;
                    z-index: 9;
                }

                .edititle3 {
                    width: 100%;
                    background: #414A58;
                    color: #fff;
                    line-height: 70px;
                    font-family: "PingFang SC";
                    font-size: 0.4rem;
                    border-radius: 10px 10px 0 0;
                    text-align: center;
                }

                .edititle3:after {
                    display: block;
                    content: '';
                    position: absolute;
                    right: 0;
                    top: 0;
                    border: 16px solid #414A58;
                    border-left: 16px solid transparent;
                    border-bottom: 16px solid transparent;
                    border-top-right-radius: 10px;
                    z-index: 9;
                }

                .edip {
                    font-size: 0.5rem;
                    color: #333333;
                    margin: 0.15rem 0 0.1rem;
                    font-family: "PingFang SC";
                    letter-spacing: 1px;
                    display: flex;
                    align-items: flex-end;

                    span {
                        font-size: 0.2rem;
                        margin-bottom: 4px;
                    }

                }

                .edips {
                    color: #999999;
                    font-size: 0.2rem;
                    line-height: 0.2rem;
                    font-family: "PingFang SC";
                    letter-spacing: 1px;
                    margin: 0.125rem 0;
                }



                .edispans {
                    width: auto;
                    display: flex;
                    flex-direction: column;
                    justify-content: flex-start;
                    align-items: flex-start;
                    letter-spacing: 2px;

                    .edispan2 {
                        display: flex;
                        align-items: center;
                        margin-bottom: 0.0625rem;

                        img {
                            width: 0.3rem;
                            height: 0.3rem;
                            margin-right: 0.0625rem;
                        }

                        span {
                            font-size: 0.225rem;
                            line-height: 0.35rem;
                            color: #626269;
                            font-family: "PingFang SC";
                        }


                    }

                }


                .editbutton {
               /*     position: absolute;
                    left: 0;
                    right: 0;
                    bottom: 0.8rem;
                    margin: auto;*/
                    margin: 0.4rem auto 0;
                    font-size: 0.225rem;
                    line-height: 0.6rem;
                    color: #fff;
                    width: 2.9rem;
                    height: 0.6rem;
                    border-radius: 0.6rem;
                    letter-spacing: 1px;
                    cursor: pointer;
                    font-family: "PingFang SC";
                }

                .editbutton:active {
                    opacity: 0.9;
                }

                .editbutton1 {
                    background: #4EAFBE;
                }

                .editbutton2 {
                    background: #4E8ABE;
                }

                .editbutton3 {
                    background: #414A58;
                }

            }


            .editionunit1:before {
                display: block;
                content: '当前版本';
                position: absolute;
                right: -2px;
                top: 15px;
                z-index: 2;
                width: auto;
                font-size: 14px;
                line-height: 20px;
                font-family: "PingFang SC";
                color: #4EAFBE;
                transform: rotate(45deg);
                -webkit-transform: rotate(45deg);
                -moz-transform: rotate(45deg);
            }

            .editionunit1:after {
                display: block;
                content: '';
                position: absolute;
                right: 0;
                top: 0;
                border: 35px solid #ffffff;
                border-left: 35px solid transparent;
                border-bottom: 35px solid transparent;
                border-top-right-radius: 10px;
            }


            .editionunit2:before {
                display: block;
                content: '当前版本';
                position: absolute;
                right: -2px;
                top: 15px;
                z-index: 2;
                width: auto;
                font-size: 14px;
                line-height: 20px;
                font-family: "PingFang SC";
                color: #4E8ABE;
                transform: rotate(45deg);
                -webkit-transform: rotate(45deg);
                -moz-transform: rotate(45deg);
            }

            .editionunit2:after {
                display: block;
                content: '';
                position: absolute;
                right: 0;
                top: 0;
                border: 35px solid #ffffff;
                border-left: 35px solid transparent;
                border-bottom: 35px solid transparent;
                border-top-right-radius: 10px;
            }


            .editionunit3:before {
                display: block;
                content: '当前版本';
                position: absolute;
                right: -2px;
                top: 15px;
                z-index: 2;
                width: auto;
                font-size: 14px;
                line-height: 20px;
                font-family: "PingFang SC";
                color: #414A58;
                transform: rotate(45deg);
                -webkit-transform: rotate(45deg);
                -moz-transform: rotate(45deg);
            }

            .editionunit3:after {
                display: block;
                content: '';
                position: absolute;
                right: 0;
                top: 0;
                border: 35px solid #ffffff;
                border-left: 35px solid transparent;
                border-bottom: 35px solid transparent;
                border-top-right-radius: 10px;
            }
        }

        .editionschange{
            position: absolute;
            left: 0;
            right: 0;
            top: 3rem;
            margin: auto;
            width: 18rem;
            /*width: 15.45rem;*/
            height: auto;
            /*background: #FFFFFF;*/
            padding: 0.25rem;
            box-sizing: border-box;
            border-radius: 0.1rem;

            backdrop-filter: saturate(180%) blur(20px);
            background-color: rgba(255,255,255,0.5);
            .changebox{
                width: 100%;
                height: 6.5rem;
                display: flex;
                justify-content: space-between;
                .change1{
                    width: 4rem;
                    height: 6.5rem;
                    background: #ffffff;
                    border-radius: 0.15rem;
                    overflow: hidden;
                    font-family: "PingFang SC";
                    box-shadow: 5px 5px 10px rgba(8, 37, 57, 0.09);
                    .change1s{
                        width: 100%;
                        height: auto;
                        position: relative;

                        img{
                            width: 100%;
                            height: auto;
                        }
                        .change1sf1{
                            position: absolute;
                            left: 0;
                            right: 0;
                            top: 0.5rem;
                            font-size: 0.4rem;
                            color: #fff;
                            opacity: 0.2;
                        }
                        .change1sf2{
                            position: absolute;
                            left: 0;
                            right: 0;
                            top: 0.9rem;
                            font-size: 0.32rem;
                            color: #fff;
                            letter-spacing: 0.03rem;
                        }
                    }
                    .content1{
                        padding: 0.1rem;
                        height: 0.8rem;
                        box-sizing: border-box;
                        width: 100%;
                        display: flex;
                        justify-content: space-around;
                        align-items: center;
                        .content11{
                            display: flex;
                            justify-content: center;
                            flex-direction: column;
                            color:#333;
                            p{
                                font-size: 0.2rem;
                            }
                            span{
                                font-size: 0.15rem;
                            }
                        }
                        .content12{
                            display: flex;
                            justify-content: center;
                            flex-direction: column;
                            color: #333333;
                            p{
                                font-size: 0.25rem;
                            }
                            span{
                                font-size: 0.15rem;
                                color:#999;
                            }
                        }
                    }
                    .content2{
                        width: 90%;
                        height: 0.02rem;
                        background:#ccc;
                        margin: 0 auto;
                    }
                    .content3{
                        width: 100%;
                        display: flex;
                        justify-content: space-around;
                        align-items: center;
                        padding: 0.1rem 0.1rem 0;
                        box-sizing: border-box;
                        .content31{
                            display: flex;
                            justify-content: space-between;
                            align-items: flex-start;
                            .content3s{
                                display: flex;
                                flex-direction: column;
                                justify-content: center;
                                .content3s1{
                                    font-size: 0.2rem;
                                    color: #333;
                                }
                                .content3s2{
                                    font-size: 0.15rem;
                                }
                            }
                            i{
                                font-size: 0.2rem;
                                color:#a0de73;
                                line-height: 0.28rem;
                                margin-left:0.05rem;
                            }
                        }
                        .content32{
                            display: flex;
                            flex-direction: column;
                            justify-content: center;
                            .content321{
                                color:#333;
                                font-size: 0.2rem;
                            }
                            .content322{
                                color:#999;
                                font-size: 0.15rem;
                            }

                        }

                    }



                }
            }

            .changefont{
                font-family: "PingFang SC";
                margin-top: 0.168rem;
                height: 0.4rem;
                display: flex;
                justify-content: space-between;
                font-size: 0.25rem;
                line-height: 0.4rem;
                color:#666;


                .bots {
                    display: flex;
                    justify-content: flex-end;
                    margin-right: 0.3rem;

                    .bots1 {
                        position: relative;

                        .bots1font {
                            font-size: 16px;
                            color: #4f8aff;
                            cursor: pointer;
                        }

                        .bots1s {
                            position: absolute;
                            bottom: 0.6rem;
                            left: -3rem;
                            width: auto;
                            height: auto;
                            background: #003982;
                            border-radius: 4px;
                            box-shadow: 0px 0px 13px 0px rgba(128, 128, 128, 0.75);
                            -webkit-box-shadow: 0px 0px 13px 0px rgba(128, 128, 128, 0.75);
                            -moz-box-shadow: 0px 0px 13px 0px rgba(128, 128, 128, 0.75);
                            padding: 0.25rem;
                            display: flex;
                            align-items: center;
                            justify-content: space-around;

                            img {
                                width: 2.5rem;
                                height: 2.5rem;
                                border-radius: 4px;
                                margin-right: 0.25rem;
                            }

                            .bots1z {
                                position: absolute;
                                right: 2.5rem;
                                bottom: -10px;
                                width: 0;
                                height: 0;
                                border-width: 0 10px 10px;
                                border-style: solid;
                                border-color: transparent transparent #003982;;
                                transform: rotate(180deg);
                            }
                            .bots2z {
                                position: absolute;
                                font-size: 0.3rem;
                                right: 0.25rem;
                                top: 0;
                                width: 0;
                                height: 0;
                                color:#ffffff;
                                cursor: pointer;
                            }

                        }

                    }

                    .bots3 {
                        position: relative;

                        .bots3font {
                            font-size: 16px;
                            color: #4f8aff;
                            cursor: pointer;
                        }

                        .bots3s {
                            position: absolute;
                            bottom: 0.6rem;
                            left: -3rem;
                            width: auto;
                            height:auto;
                            background: #003982;
                            border-radius: 4px;
                            box-shadow: 0px 0px 13px 0px rgba(128, 128, 128, 0.75);
                            -webkit-box-shadow: 0px 0px 13px 0px rgba(128, 128, 128, 0.75);
                            -moz-box-shadow: 0px 0px 13px 0px rgba(128, 128, 128, 0.75);
                            display: flex;
                            align-items: center;
                            padding: 0.25rem;
                            box-sizing: border-box;
                            justify-content: flex-start;

                            img {
                                width: 2.5rem;
                                height: 2.5rem;
                                border-radius: 4px;
                                margin-right: 0.25rem;
                            }

                            .bots1z {
                                position: absolute;
                                right: 2.5rem;
                                bottom: -10px;
                                width: 0;
                                height: 0;
                                border-width: 0 10px 10px;
                                border-style: solid;
                                border-color: transparent transparent #003982;;
                                transform: rotate(180deg);
                            }
                            .bots2z {
                                position: absolute;
                                right: 0.25rem;
                                top: 0;
                                width: 0;
                                height: 0;
                                color:#ffffff;
                                cursor: pointer;
                                font-size: 0.3rem;

                            }
                        }
                    }

                    /*.bots1:active,bots3:active{*/
                    /*    opacity: 0.85;*/
                    /*}*/
                    .bots2 {
                        font-size: 16px;
                        color: #4f8aff;
                        margin: 0 10px;

                    }
                }
            }

        }
    }
</style>